import * as React from 'react'
import PropTypes from 'prop-types'

import {
  Container,
  Subtitle,
  Title
} from './style'

const QuoteCredits = ({
  title = '',
  subtitle = ''
}) => {
  return (
    <Container>
      { !!subtitle && (<Subtitle>{ subtitle }</Subtitle>) }
      { !!title && (<Title>{ title }</Title>) }
    </Container>
  )
}

QuoteCredits.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string
}

export default QuoteCredits
